import {
  Box,
  Stack,
} from "@mui/material";
import { IncidentTypeSelection } from "./IncidentType/IncidentTypeSelection";
import { CenterSelection } from "./Center/CenterSelection";
import { IncidentTime } from "./IncidentTime/IncidentTime";
import { DepartmentSelection } from "./Department/DepartmentSelection";
import React from "react";
import { useMyProfileQuery } from "../../../../../services/profileService/profile-api";
import { useAppSelector } from "../../../../../app/hooks";
import { PermissionChecker } from "../../../../../services/varianceService/util/PermissionChecker";

function VarianceHeader() {
  const incident = useAppSelector(state  => state.varianceRequest.varianceRequest);  const { data } = useMyProfileQuery();  const canEdit = (): boolean => {
    return PermissionChecker.canEditVariance(data, incident);
  }

  const isAdmin = (): boolean => {
    return PermissionChecker.isVarianceAdmin(data, incident.center);
  }

  return (
    <React.Fragment>
      <Box mt={2} mb={2}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={3}
        >
          {isAdmin() && <CenterSelection canEdit={canEdit()}/>}
          <DepartmentSelection canEdit={canEdit()}/>
          <IncidentTypeSelection canEdit={canEdit()}/>
          <IncidentTime canEdit={canEdit()}/>
        </Stack>
      </Box>
    </React.Fragment>
  );
}

export { VarianceHeader };
